module.exports = __webpack_public_path__ + "img/mastercard.683cbd23.png";